<template>
  <div>
    <Head title="Sorting Consumption" />
    <h1 class="mb-8 text-3xl font-bold">Sorting Consumption</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md mr-3" @reset="reset" />
      <a
        v-if="(sortings.data.length > 0 && url())"
        class="btn-orange"
        :href="`/sorting-consumption/download${url()}`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date Sorted</th>
          <th class="pb-3 pt-3 px-3">UID</th>
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Description</th>
          <th class="pb-3 pt-3 px-3">PO Number</th>
          <th class="pb-3 pt-3 px-3">Supplier</th>
          <th class="pb-3 pt-3 px-3">Container Number</th>
          <th class="pb-3 pt-3 px-3">Component Part Number</th>
          <th class="pb-3 pt-3 px-3">Component Part Description</th>
          <th class="pb-3 pt-3 px-3">Quantity</th>
        </tr>
        <tr v-for="sorted in sortings.data" :key="sorted.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.uid }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.part_number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.po_number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.supplier }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.container_number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.component_part_number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.component_part_description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="" title="">
              {{ sorted.quantity }}
            </Link>
          </td>
        </tr>
        <tr v-if="sortings.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="sortings.links" />
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import DateRange from '@/Shared/DateRange'
      
export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    DateRange,
  },
  layout: Layout,
  props: {
    filters: Object,
    sortings: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/sorting-consumption', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    url() {
      let query = ''
      if (this.form.search) {
        if (query) {
          query += '&'
        }
        query += `search=${this.form.search}`
      }
      if (this.form.dateValue) {
        if (query) {
          query += '&'
        }
        query += `dateValue=${this.form.dateValue}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
  },
}
</script>
      